import { render, staticRenderFns } from "./ImportClassTimesheetSubstitute.vue?vue&type=template&id=5d7fa152&scoped=true"
import script from "./ImportClassTimesheetSubstitute.vue?vue&type=script&lang=js"
export * from "./ImportClassTimesheetSubstitute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7fa152",
  null
  
)

export default component.exports